export default __webpack_public_path__ + "static/media/docket.d9ef59c8.svg";